import { c as _c } from "react/compiler-runtime";
import { assertUnreachable } from "@/helpers/AllowlistToolHelpers";
import DropListItemContentNft from "./nft-tag/DropListItemContentNft";
import DropListItemContentGroupMention from "./DropListItemContentGroupMention";
import DropListItemContentMention from "./DropListItemContentMention";
import DropListItemContentWaveMention from "./DropListItemContentWaveMention";
import { DropContentPartType, type DropListItemContentPartProps } from "./DropListItemContentPart.types";
export default function DropListItemContentPart(t0) {
  const $ = _c(9);
  const {
    part
  } = t0;
  const {
    type,
    value
  } = part;
  switch (type) {
    case DropContentPartType.MENTION:
      {
        let t1;
        if ($[0] !== value) {
          t1 = <DropListItemContentMention user={value} />;
          $[0] = value;
          $[1] = t1;
        } else {
          t1 = $[1];
        }
        return t1;
      }
    case DropContentPartType.GROUP_MENTION:
      {
        let t1;
        if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <DropListItemContentGroupMention />;
          $[2] = t1;
        } else {
          t1 = $[2];
        }
        return t1;
      }
    case DropContentPartType.HASHTAG:
      {
        let t1;
        if ($[3] !== value) {
          t1 = <DropListItemContentNft nft={value} />;
          $[3] = value;
          $[4] = t1;
        } else {
          t1 = $[4];
        }
        return t1;
      }
    case DropContentPartType.WAVE_MENTION:
      {
        let t1;
        if ($[5] !== value) {
          t1 = <DropListItemContentWaveMention wave={value} />;
          $[5] = value;
          $[6] = t1;
        } else {
          t1 = $[6];
        }
        return t1;
      }
    default:
      {
        let t1;
        if ($[7] !== type) {
          t1 = assertUnreachable(type);
          $[7] = type;
          $[8] = t1;
        } else {
          t1 = $[8];
        }
        return t1;
      }
  }
}